import { themedUseStyletron } from '../../../theme/customTheme'
import { ILight } from './types'
import { FaRegLightbulb } from 'react-icons/fa'

export function SmallPanel(props: ILight) {
    const [, theme] = themedUseStyletron();

    return (
        <>
            <FaRegLightbulb color={props.isOn ? theme.colors.warning : theme.appColors.aggregate.off} size='25px' />
        </>
    );
}